"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
var react_1 = require("react");
var Translation_1 = require("../../../../../../common/components/presentation/Translation/Translation");
var PriceDisplayType_1 = require("../../../../../../../../common/enum/PriceDisplayType");
var ContentLine_1 = require("../../contentLine/ContentLine");
var Price_1 = require("../../../../../common/components/prices/price/Price");
exports.GovermentChargesOption = function (_a) {
    var style = _a.style, govChargesPrice = _a.govChargesPrice, currency = _a.currency;
    var _b;
    if (!govChargesPrice)
        return null;
    return (<ContentLine_1.default dataTest={"summary:option:total_price_tax"} className={(_b = style) === null || _b === void 0 ? void 0 : _b.option} mainContent={<core_1.Typography variant="subtitle1" component="span">
          <Translation_1.default id="trans__configurator__customise_page_summary_section__selection_accessory_goverment_charges"/>
        </core_1.Typography>} secondaryContent={<Price_1.default price={govChargesPrice} priceDisplayType={PriceDisplayType_1.PriceDisplayType.PRIMARY} currency={currency}/>}/>);
};
